module.exports = __webpack_public_path__ + "img/68.101e7d93.jpeg";